import TemplateView from '../../../../TemplateView'
import GroupItem, {Type} from './GroupItem'

export default class ManageGroupsDropdownDialog extends TemplateView {
    constructor({
        timeZoneOnClick = () => {},
        departmentsOnClick = () => {},
    }) {
        super()
        this.timeZoneOnClick = timeZoneOnClick
        this.departmentOnClick = departmentsOnClick
    }

    templateHtml() {
        return "<div></div>"
    }

    afterRender() {
        new GroupItem({
            type: Type.TIME_ZONE_GROUP,
            additionalClass: 'option',
            onClick: this.timeZoneOnClick
        }).init(this.$el)

        new GroupItem({
            type: Type.DEPARTMENT,
            additionalClass: 'option',
            onClick: this.departmentOnClick
        }).init(this.$el)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/ManageGroupsList.js